import { useForm } from '../../hooks/useForm'
import {  useDispatch, useSelector } from 'react-redux';
import { filterDeliveryDonwload } from '../../actions/deliveryNotes';
import './delivery.css';
import RolesConstants  from '../../constant/roles';
import moment from 'moment';
import { BtnLogout } from '../ui/BtnLogout';
import { BtnDownload } from '../ui/BtnDownload';
import { BtnDownloads} from '../ui/BtnDownloads';
import { BtnBack } from '../ui/BtnBack';
import { BtnReload } from '../ui/BtnReload';
import { Collapse, Tooltip, Space } from 'antd';
import { useParams } from 'react-router-dom';
import { DataGrid, esES } from '@mui/x-data-grid';
import { useState } from 'react';
import { CustomToolbar } from '../../helpers/customtoolbar';
import { PdfPreviewModal } from '../modal/PdfPreviewModal';
import { DownloadProgressModal } from '../modal/DownloadProgressModal';

const { Panel } = Collapse;

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossorigin="anonymous"></script>

const columns = [
    {
        headerName: 'CÓDIGO ARTÍCULO',
        field: 'narticle',
        flex: 2,
    },
    {
        headerName: 'DESCRIPCIÓN',
        field: 'description',
        renderCell: (record) =>  (
            <Tooltip placement="topLeft" title={record.row.description} >
                <span className="table-cell-trucate">{record.row.description}</span>
            </Tooltip>
        ),
        flex: 4,
    },
    {
        headerName: 'EAN',
        field: 'ean',
        flex: 2,
    },
    {
        headerName: 'SSCC',
        field: 'sscc',
        flex: 2,
    },
    {
        headerName: 'RECIBIDAS',
        field: 'received',
        flex: 1,
    },
    {
        headerName: 'NO RECIBIDAS',
        field: 'noreceived',
        flex: 1,
    },
    {
        headerName: 'Nº PEDIDO',
        field: 'ordercode',
        flex: 1,

    },
    {
        headerName: 'ALBARAN PROVEEDOR',
        field: 'deliverynote',
        flex: 2,
    },
    {
        headerName: 'CÓDIGO PROVEEDOR',
        field: 'providercode',
        flex: 2,
    },
    {
        headerName: 'NOMBRE PROVEEDOR',
        field: 'providername',
        flex: 2,
    },
    {
        headerName: 'Acción',
        field: 'action',
        flex: 1,
        renderCell: (record) => (
            <Space size="middle">
                <BtnDownload  delivery= { record.row}/>
            </Space>
        ),
    },
]

export const DeliveryScreen = ( {history} ) => {

    const { delivery } = useSelector(state => state.delivery);
    const { stores } = useSelector(state => state.store);
    const { rol } = useSelector(state => state.auth);
    const { orderDeliveryId, storeId, secId } = useParams();
    const dispatch = useDispatch();

    const [pageSize, setPageSize] = useState(10);

    const dateEnd = moment().format("yyyy-MM-DD");
    let dateIni = moment();
    const intervalMovement = window.APP_CONFIG.daymovement;

    dateIni = dateIni.subtract(intervalMovement, "days");
    dateIni = dateIni.format("yyyy-MM-DD");
    //storeId = storeId !== undefined ? storeId : '';

    const [ formRegisterValues, handleRegisterInputChange ] = useForm({
        store_id: storeId !== '' ? storeId : '',
        sdate: dateIni,
        edate: dateEnd,
        deliverynote: orderDeliveryId !== undefined && secId === '2' ? orderDeliveryId : '',
        ordercode: orderDeliveryId !== undefined && secId === '1' ? orderDeliveryId : '',
        providercode: '',
        narticle: '',
    });

    const { store_id, sdate, edate, deliverynote, ordercode, providercode, narticle } = formRegisterValues

    const handleFilter = (e) => {
        e.preventDefault();
        dispatch(filterDeliveryDonwload(formRegisterValues));
    }

    return (
        <div>
            <section id="general-hdr">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <BtnBack history={history}/>
                            <h1 className="section-name">Albaranes</h1>
                        </div>
                        <div className="col-auto"><BtnLogout/></div>
                    </div>
                </div>
            </section>
            <section id="filters-zone">
                <div className="container-fluid pt-2 pb-2 mb-2">

                    <div className="accordion accordion-flush" id="accordionFlushExample">
                        <Collapse accordion>
                            <Panel header="Filtrar productos" key="1">
                            <div id="flush-collapseOne" className="accordion-collapse " aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">

                                    <form onSubmit={ handleFilter } className="mmk-form">
                                        { (rol !== RolesConstants.STORE) &&
                                        <div className="row mb-2">
                                            <div className="col">
                                                <label className="form-label" >Tienda </label>
                                                <select
                                                    defaultValue={store_id}
                                                    name="store_id"
                                                    className='form-select form-select-md shop-sel'
                                                    onChange= { handleRegisterInputChange }
                                                >
                                                    <option key={0} value=''>TODAS LAS TIENDAS</option>
                                                    {
                                                        (
                                                            stores.map((item,i)=>(
                                                            <option key={"stores"+i} value={item.id}>{item.code} - {item.name}</option>
                                                        ))
                                                        )
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        }

                                        <div className="row mb-2">
                                        <div className="col-12 col-lg">
                                                <label className="form-label">Fecha de Inicio</label>
                                                <input
                                                    type="date"
                                                    name="sdate"
                                                    value= { sdate }
                                                    className='form-control'
                                                    onChange= { handleRegisterInputChange }
                                                />
                                            </div>
                                            <div className="col-12 col-lg">
                                                <label className="form-label">Fecha de Fin</label>
                                                <input
                                                    type="date"
                                                    name="edate"
                                                    value= { edate }
                                                    className='form-control'
                                                    onChange= { handleRegisterInputChange }
                                                />
                                            </div>
                                            <div className="col-12 col-lg">
                                                <label className="form-label">Número de Albarán</label>
                                                <input
                                                    type="text"
                                                    name="deliverynote"
                                                    value= { deliverynote }
                                                    className='form-control'
                                                    onChange= { handleRegisterInputChange }
                                                />
                                            </div>
                                            <div className="col-12 col-lg">
                                                <label className="form-label">Número de Pedido</label>
                                                <input
                                                    type="text"
                                                    name="ordercode"
                                                    value= { ordercode }
                                                    className='form-control'
                                                    onChange= { handleRegisterInputChange }
                                                />
                                            </div>
                                            <div className="col-12 col-lg">
                                                <label className="form-label">Código Proveedor</label>
                                                <input
                                                    type="text"
                                                    name="providercode"
                                                    value= { providercode }
                                                    className='form-control'
                                                    onChange= { handleRegisterInputChange }
                                                />
                                            </div>
                                            <div className="col-12 col-lg">
                                                <label className="form-label">Código de Artículo</label>
                                                <input
                                                    type="text"
                                                    name="narticle"
                                                    value= { narticle }
                                                    className='form-control'
                                                    onChange= { handleRegisterInputChange }
                                                />
                                            </div>
                                        </div>
                                        <div className="row justify-content-end mb-2">
                                            <div className="col-12 col-lg-3">
                                                <div className="d-grid gap-2">
                                                    <button type="submit" className="btn btn-primary">APLICAR</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            </Panel>
                        </Collapse>
                    </div>
                </div>
            </section>
            <div className='table-container'>
                <BtnReload props={'delivery'} data={formRegisterValues}/>
                <BtnDownloads props={'delivery'} data={delivery}/>
                <div className="table-style-stock margin-top">
                    <DataGrid
                        rows={delivery}
                        columns={columns}
                        getRowId={(row) => `${row.narticle}-${Math.random().toString(36).substr(2, 9)}`}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        components={{ Toolbar: CustomToolbar  }}
                    />
                </div>
            </div>
            <PdfPreviewModal/>
            <DownloadProgressModal/>
        </div>
    )
}